module.exports = __webpack_public_path__ + "static/media/Warning.973a1d2e.svg";